/**
 * Get the version of a given environment.
 */
export const getVersion = env => dispatch => {
    window.axios.get(`api/version?env=${env}`).then(response => {
        dispatch({
            payload: {
                env,
                version: response.data,
            },
            type: 'GET_VERSION',
        });
    });
};



// WEBPACK FOOTER //
// ./src/actions/version.js